/* global Swiper */
class CustomHeroSlider extends HTMLElement {
  constructor() {
    super();
    this.slider = null;
  }

  connectedCallback() {
    this.init();
  }

  init() {
    // The element itself is the swiper container because it has the 'swiper' class
    // and contains the 'swiper-wrapper'
    this.slider = new Swiper(this, {
      loop: true,
      slidesPerView: 1,
      threshold: 10, // Add some threshold for better touch experience
      navigation: {
        nextEl: this.querySelector(".swiper-button-next"),
        prevEl: this.querySelector(".swiper-button-prev"),
      },
      pagination: {
        el: this.querySelector(".swiper-pagination"),
        clickable: true,
      },
    });
  }

  disconnectedCallback() {
    if (this.slider) {
      this.slider.destroy();
    }
  }
}

customElements.define("custom-hero-slider", CustomHeroSlider);
